<template>
	<card type="cinc" class="ReClientNoteMsg lightTheme mb-3 ">
		<div slot="header">
			<div class="row align-items-center">
				<div class="col">                
					<span class="badge badge-pill badge-success mr-1">WhatsApp</span>
					<span class="badge badge-pill badge-primary mr-1" v-if="objNote.direction!='' && objNote.direction=='in'">Входящее</span>
					<span class="badge badge-pill badge-primary mr-1" v-if="objNote.direction!='' && objNote.direction=='out'">Исходящее</span>
					<!-- <span class="badge badge-pill badge-info mr-1" v-if="objNote.send_status == 1 || objNote.send_status == 0">В обработке</span>
					<span class="badge badge-pill badge-primary mr-1" v-if="objNote.send_status == 2">Отправлено</span> -->

					<div class="date note-title">
						<span v-if="objNote.staff_name!=''" class="mr-2">Отправитель: {{objNote.staff_name}}</span>
						<!-- <span v-if="objNote.client_name!=''" class="mr-2">Клиент: {{objNote.client_name}}</span> -->
						<span v-if="objNote.InsertTime!=''">{{$GVO.convertDateTimeFromMysql(objNote.InsertTime)}}</span>
					</div>
				</div>
			 </div>
		</div> 

		<div class="note-content" v-if="!bIsEdit && objNote.mess_body!=''">
			<template v-if="objNote.mess_type.includes('image') || objNote.mess_type=='sticker'">
				<img class="note-photo" :src="`data:image/png;base64,${objNote.mess_body}`" alt="картинка с ватсапа"> 
			</template>
			<template v-else-if="objNote.mess_type=='ptt'">
				<audio controls :src="`data:audio/ogg;base64,${objNote.mess_body}`"/>
			</template>
			<template v-else-if="objNote.mess_type=='video'">
				<video controls :src="`data:video/mp4;base64,${objNote.mess_body}`"/>
			</template>
			<template v-else-if="objNote.mess_type.includes('attach')">
				<a :href="`data:${objNote.mess_type};base64,${objNote.mess_body}`">Скачать файл с содержимым objNote.mess_body {{objNote.id}}.{{objNote.mess_type.replace('attach/','')}}</a>
			</template>
			<template v-else><p class="mt-2" v-html="$GVO.parseLink(objNote.mess_body)"></p></template>
			<!-- <form v-if="bIsEdit" class="form-container">
				<div class="top_part">           
					<textarea 
						class="form-control"
						placeholder="Текст"
						ref="saveInput"						
						v-model="strNote">	
					</textarea>	
				</div>
				<div class="bottom_part mt-2 pb-1">
					<base-button type="success" simple icon @click="UpdNote()" class="mr-0"><i class="d-inline-block tim-icons icon-send"></i></base-button>
				</div>
			</form> -->
		</div>  
		<!-- <div class="note-docs" v-if="objNote.atach_arr !='' && objNote.atach_arr != null">
			<i class="d-inline-block tim-icons icon-paper text-primary mr-2"></i>
			<a :href="objNote.atach_arr.fullpath" target="_blank">{{objNote.atach_arr.src_filename}}</a>
		</div> -->
		<!-- <template v-if="!bIsEdit && isShownInTicket">
			<div class="date mt-2" v-if="objNote.UpdTime != objNote.InsTime"><span class="d-flex justify-content-end">Ред.: {{$GVO.convertDateTimeFromMysql(objNote.UpdTime)}}</span></div>
		</template> -->
	</card>
</template>

<script>
// import ReFileUpload from "src/our_components/ReFileUpload.vue";

export default {
	name: 'ReClientNoteMsg',
	components: {
		// ReFileUpload,
	},
	props: {
		counter: String,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',            
		},
		objNote: {
			type: Object,
			default: function() {
				return {};
			}
		},
	},
	data () {
		return {
			ver: 1, 
			bIsEdit: false,
			strNote: '',
		}
	},
	computed: {
		// dt_update(){
		// 	return this.objNote.UpdTime;
		// }
	},
	methods: {     

		// GoToEdit(){
		// 	this.strNote = this.objNote.message;
		// 	this.bIsEdit = true;
		// },
		// UpdNote(){	
		// 	this.$GVO.ApiCall('UPD',{obj:'NOTES',flt:{'id': this.objNote.id},uData:{'descr':this.strNote}})
		// 	.then((objApi) => {
		// 		//console.log(objApi);
		// 		if(objApi.success === true){
		// 			this.bIsEdit = false;
		// 			this.strNote = '';
		// 			this.$emit('onUpdate', true);
		// 		} 						
		// 	}).catch(errorObjApi => console.log(errorObjApi));		
		// }
	},
	created(){

	}
}
</script>
<style scoped>
.ReClientNoteMsg {border: 1px solid rgba(1, 176, 224, 0.4);}
.ReClientNoteMsg .date {
	font-size: 12px;
	/* color: #9A9A9A; */
	/* color: #01B0E0; */
	margin-top: 5px;
}
.ReClientNoteMsg >>> .card-body {padding: 0px 15px 15px 15px; }
.badge-grey {background: #9A9A9A; color: #fff;}
.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4;}
.call-audio {
    background-color: transparent;
    border: 1px solid #01B0E0;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.note-photo {display: block; width: 100%; height: 100%; max-width: 450px; object-fit: contain; margin-top: 10px;}

@media (max-width: 768px) {	
	.note-content {
		padding: 0px;
	}
	.note-title {
		display: flex;
		flex-direction: column;
	}
}
</style>
